import React from 'react';
import {
  IPlanOverviewDetail,
  ISubjectSubscription,
} from '@models/interfaces/user.interface';
import ChevronDown from '@assets/icons/chevron-down';
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import { planName } from '@components/subscription/overview/helper/PlanDetailHelper';
import { getRenewalDate } from '@components/subscription/helper/SubscriptionHelper';

export interface SubscriptionCardNavigationProps {
  subscription: ISubjectSubscription;
  planDetail: IPlanOverviewDetail;
  className?: string;
}

const SubscriptionCardNavigation = ({
  subscription,
  className,
  planDetail,
}: SubscriptionCardNavigationProps) => {
  const expiryDate = moment(subscription.expiry_date + '+08:00').format(
    'D MMM YYYY',
  );
  const renewDate = getRenewalDate(subscription, planDetail).format(
    'D MMM YYYY',
  );
  const navigate = useNavigate();

  function handleClickSubscription() {
    navigate('plan-overview');
  }

  function getDescription() {
    if (subscription.is_trial_plan || !subscription.auto_renewal) {
      return 'Expires on ' + expiryDate;
    }

    return 'Renews on ' + renewDate;
  }

  return (
    <div
      className={
        'p-4 bg-neutral-chalk rounded-xl shadow-[4px_-4px_0_0_#CFD7E5_inset] relative cursor-pointer overflow-hidden ' +
        (className ?? '')
      }
      onClick={handleClickSubscription}
      data-testid={'card-navigation'}
    >
      <div className={'flex'}>
        <div className={'flex-grow flex-shrink'}>
          <p
            className={
              'font-bold text-primary-navyblue leading-normal line-clamp-2'
            }
          >
            {planName(planDetail)}
          </p>
          <p className={'text-neutral-pencil max-lg:text-xs lg:text-sm'}>
            {getDescription()}
          </p>
        </div>
        <div className={'self-center'}>
          <ChevronDown
            className={'fill-current text-primary-apricot -rotate-90 h-4'}
          />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCardNavigation;
